import React, {Component} from 'react';
import {Checkbox} from 'antd';
import './SACheckbox.css';
import {injectIntl} from "react-intl";

class SACheckbox extends Component {

  render() {
    const {intl:{formatMessage}, error, ...attributes } = this.props;

    return (
      <div className={error && error[this.props.name] ? " error":''}>
        <Checkbox {...attributes}/>
          {error && error[this.props.name] && (
            <span className='txt-error'>{formatMessage({id: error[this.props.name].message})}</span>
          )}
      </div>
    );
  }
}

export default injectIntl(SACheckbox);



// WEBPACK FOOTER //
// ./src/components/common/input/SACheckbox.js